import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, y = 36, className = '', once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterLabel({ index, title, dark = false }) {
  return (
    <Reveal className="flex items-center gap-4">
      <span
        className={`font-display text-xs font-bold tracking-[0.35em] uppercase ${
          dark ? 'text-brand' : 'text-brand'
        }`}
      >
        {index}
      </span>
      <span className={`h-px w-12 ${dark ? 'bg-white/25' : 'bg-slate-300'}`} />
      <span
        className={`text-xs font-semibold tracking-[0.35em] uppercase ${
          dark ? 'text-slate-300' : 'text-slate-500'
        }`}
      >
        {title}
      </span>
    </Reveal>
  );
}
